export default "__VITE_PUBLIC_ASSET__5638716e__"